import React, { useState, useEffect } from "react";
// import Logo from "../../../assets/Credin Logo (1).svg";
import "./EditLead.css";
import { TextField,MenuItem } from "@mui/material";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation, useNavigate } from "react-router-dom";
// import { Link } from "react-router-dom";
import { AiOutlineTable } from "react-icons/ai";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Sidebar from "../../../Sidebar/Sidebar";
import Button from "@mui/material/Button";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import {url} from '../../../App'
import Cookies from 'js-cookie';

export default function EditLead() {

  const [open, setOpen] = React.useState(false);

  const navigate = useNavigate();

  const [data, setData] = useState([]);
  const [data2, setData2] = useState([]);
  const [data3, setData3] = useState([]);
  const [branchName, setBranchName] = useState("");

  const [isOpen, setIsOpen] = useState(true);
  const openView = (val) => setIsOpen(val);
  const token = Cookies.get('Token');
  const email = Cookies.get('Email');
  const [firstName, setFirstName] = useState("");
  const [middleName, setMiddleName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [leadEmail, setLeadEmail] = useState("");
  const [pan, setPan] = useState("");
  const [aadhaar, setAadhaar] = useState("");
  const [voterId, setVoterId] = useState("");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [companyIdSuperadmin,setCompanyIdSuperadmin] = useState("");
  const [branchIdSuperadmin,setBranchIdSuperadmin] = useState("");
  const [sourceIdSuperadmin, setsourceIdSuperadmin] = useState("");
  const [connectorData, setConnectorData] = useState([]);
  const [connector, setconnector] = useState("");
  const { state } = useLocation();
  const [leadType, setLeadType] = useState("");
  const [visible, setvisible] = useState(false);
  const [companyIdVisible, setCompanyIdVisible] = useState(false);
  console.log(state);

  useEffect(() => {
    axios
    .post(url + "/lead/getsingle", {
      token: token,
      email: email,
      lead_id:state.lead_id
    })
    .then((res) => {
      fetchconnectorData(res.data[0].lead_source)
      if (res.data.logout === true) {
        toast.error(res.data.message);
        setTimeout(() => {
           navigate("/");
        }, 3000);
      } 
    })
    .catch((err) => {
      console.log(err);
      toast.error(err.message);
    });

    const fetchconnectorData = async (staff_id) => {
      let headers = {
        token: token,
        email: email,
      }
      let connectorData = await axios.get(`${url}/connector/get/${staff_id}`,{
        headers: headers
      })
      setConnectorData(connectorData.data.data)
    }

    if (email === "rupesh.bishnoi@credin.in") {
      setvisible(true);
    } else {
      axios
        .post(url + "/user/getsingle", {
          token: token,
          email: email,
          useremail: email
        })
        .then((res) => {
          setCompanyIdVisible(res.data[0].permission.company_branch_source_mapping);
        })
        .catch((err) => {
          // console.log(err);
          toast.error(err.message);
        })
    };
    
      if(email === "rupesh.bishnoi@credin.in" || setCompanyIdVisible){

        axios
        .post(url+"/company/dropdownarray", {
          token: token,
          email: email,
        })
        .then((res) => {
          if (res.data.auth === false) {
            
          } else {
            setData(res.data);
          }
        })
        .catch((err) => {
          console.log(err);
        });

        axios
        .post(url+"/branch/companytobranch", {
          company_id: state.lead_companycode,
          token: token,
          email: email,
        })
        .then((res) => {
          if (res.data.auth === false) {
          } else {
            setData2(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });

        axios
        .post(url + "/user/branchtouser", {
          staff_branch: state.lead_branchcode,
          token: token,
          email: email,
        })
        .then((res) => {
          if (res.data.auth === false) {
          } else {
            setData3(res.data.message);
          }
        })
        .catch((err) => {
          console.log(err);
        });
      }
      
      if (!state) {
        navigate("/");
      } else {
        console.log(state);
        setFirstName(state.lead_firstname);
        setMiddleName(state.lead_middlename);
        setLastName(state.lead_lastname);
        setPhoneNumber(state.lead_mobile);
        setLeadEmail(state.lead_email);
        setPan(state.lead_pan);
        setAadhaar(state.lead_aadhaar_no)
        setVoterId(state.lead_voter_no)
        setDateOfBirth(state.lead_dob);
        setCompanyIdSuperadmin(state.lead_companycode);
        setBranchIdSuperadmin(state.lead_branchcode);
        setsourceIdSuperadmin(state.lead_source);
        setconnector(state.lead_connector_id)
        setLeadType(state.lead_type);
      }
    }, [token,email,state,navigate]);

 

  const handleSubmit = (e) => {
    e.preventDefault();
    // toast.info("Updating Details...", {
    //   autoClose: false,
    //   toastId: "custom",
    // });
    setOpen(true);
    var reqArray = {
        token: token,
        email: email,
        lead_firstname: firstName,
        lead_middlename: middleName,
        lead_lastname: lastName,
        // lead_mobile: phoneNumber,
        // lead_email: leadEmail,
        // lead_pan: pan,
        lead_dob: dateOfBirth,
        lead_id: state.lead_id,
        // lead_companycode: companyIdSuperadmin,
        // lead_branchcode: branchIdSuperadmin,
        // lead_source: source,
        // lead_status: status,
        // lead_credit_score: score,
        lead_connector: connector,
        lead_type: leadType
      }
      if(email === 'rupesh.bishnoi@credin.in' || setCompanyIdVisible){
        reqArray.lead_companycode = companyIdSuperadmin
        reqArray.lead_branchcode = branchIdSuperadmin
        reqArray.lead_source = sourceIdSuperadmin
        reqArray.lead_branchname = branchName
      }
      // console.log(reqArray)
    axios
      .post(url+"/lead/update", reqArray)
      .then((res) => {
        if(res.data.auth === true){

          // console.log(res);
          // toast.dismiss("custom");
          setOpen(false);
          toast.success(res.data.message);
          setTimeout(() => {
            // navigate("/lead/view");
            window.location.reload()
          }, 2000);
        }
        else{
          // console.log(res);
          // toast.dismiss("custom");
          setOpen(false);
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        // console.log(err);
        setOpen(false);
        toast.error(err);
      });
  };

  const handleCompanyId = (event) => {
    setCompanyIdSuperadmin(event.target.value);
    setBranchIdSuperadmin("");
    // console.log(event.target.value);
    axios
      .post(url+"/branch/companytobranch", {
        company_id: event.target.value,
        token: token,
        email: email,
      })
      .then((res) => {
        if (res.data.auth === false) {
          // toast.dismiss("custom");
          // toast.error(res.data.message);
          // navigate("/");
        } else {
          // console.log(res.data);
          // toast.dismiss("custom");
          // toast.success("Loans Fetched Successfully");
          setData2(res.data.message);
          // console.log(res.data.message[0].branch_id);
        }
      })
      .catch((err) => {
        // console.log(err);
        // toast.dismiss("custom");
        // toast.error(err.message);
      });
  }

  const handleBranchId = (event) => {
    setBranchIdSuperadmin(event.target.value);
    console.log(event.target.value, 'branchname');

    const selectedBranchId = event.target.value;
    const selectedBranch = data2.find(
      (item) => item.branch_id === selectedBranchId
    );
    console.log(selectedBranch.branch_name);
    setBranchName(selectedBranch.branch_name);

    axios
      .post(url + "/user/branchtouser", {
        staff_branch: event.target.value,
        token: token,
        email: email,
      })
      .then((res) => {
        if (res.data.auth === false) {
          // toast.dismiss("custom");
          // toast.error(res.data.message);
          // navigate("/");
        } else {
          // console.log(res.data);
          // toast.dismiss("custom");
          // toast.success("Loans Fetched Successfully");
          setData3(res.data.message);
          // console.log(res.data.message[0].branch_id);
        }
      })
      .catch((err) => {
        // console.log(err);
        // toast.dismiss("custom");
        // toast.error(err.message);
      });
  }

  const handlefirstName = (e) => {
    var reg = /^([a-zA-Z\s]{0,100})$/;
    // console.log(e.target.value);
    if (reg.test(e.target.value)) {
      setFirstName(e.target.value);
    }
  };

  const handlemiddleName = (e) => {
    var reg = /^([a-zA-Z\s]{0,100})$/;
    // console.log(e.target.value);
    if (reg.test(e.target.value)) {
      setMiddleName(e.target.value);
    }
  };

  const handlelastName = (e) => {
    var reg = /^([a-zA-Z\s]{0,100})$/;
    // console.log(e.target.value);
    if (reg.test(e.target.value)) {
      setLastName(e.target.value);
    }
  };

  return (
    <>
      {/* <div className="background-edit-lead">
      <div className="container-edit-lead"> */}
      {/* <div className="image-edit-lead">
          <img src={Logo} alt="" className="logo-image-edit-lead" />
        </div> */}

      {/* <div className="editLead-edit-lead">
          <p className="heading-edit-lead">
            <strong>Edit Lead</strong>
          </p>
          <Link to="/lead/view">
            <button className="btn1">
              <ArrowBackIcon /> Back
            </button>
          </Link>
        </div> */}
      <div style={{ height: "20px" }} />
      <Sidebar click={openView} />
      <div style={{ marginLeft: isOpen ? "15%" : "0", transition: "all 0.2s" }}>
        <div className="main-container">
          <div className="content-container">
            <h3 className="main-heading">
              <AiOutlineTable />
              Edit Lead
            </h3>
            <div className="inputsField-edit">
              <form
                action=""
                onSubmit={handleSubmit}
                className="edit-lead-form"
              >
                <div className="form-edit-lead">
                  <div className="input-div">
                    <label>First Name*</label>
                  <TextField
                    name="firstName"
                    placeholder="First Name"
                    size="small"
                    onChange={(e) => handlefirstName(e)}
                    value={firstName}
                    required
                    disabled={state.lead_source !== "ONA"}
                  />
                  </div>
                  <div className="input-div">
                    <label>Middle Name</label>
                  <TextField
                    name="middleName"
                    placeholder="Middle Name"
                    size="small"
                    // required
                    onChange={(e) => handlemiddleName(e)}
                    value={middleName}
                    disabled={state.lead_source !== "ONA"}
                  />
                  </div>
                  <div className="input-div">
                    <label>Last Name*</label>
                  <TextField
                    name="lastName"
                    placeholder="Last Name"
                    size="small"
                    onChange={(e) => handlelastName(e)}
                    value={lastName}
                    // required
                    disabled={state.lead_source !== "ONA"}
                  />
                  </div>
                  <div className="input-div">
                    <label>Mobile Number</label>
                  <TextField
                    name="phoneNumber"
                    placeholder="Phone No."
                    size="small"
                    type="number"
                    disabled
                    value={phoneNumber}
                  />
                  </div>
                  <div className="input-div">
                    <label>Email</label>
                  <TextField
                    name="email"
                    size="small"
                    placeholder="Email ID"
                    // required
                    disabled={state.lead_source !== "ONA"}
                    // onChange={(e) => setLeadEmail(e.target.value)}
                    value={leadEmail}
                    type="email"
                  />
                  </div>
                  <div className="input-div">
                    <label>PAN Number</label>
                  <TextField
                    name="pan"
                    // onChange={(e) => setPan(e.target.value)}
                    value={pan}
                    size="small"
                    disabled={state.lead_source !== "ONA"}
                    // required
                    placeholder="PAN Number"
                  />
                  </div>
                  <div className="input-div">
                    <label>Aadhaar Number*</label>
                    <TextField
                      name="aadhaar"
                      onChange={(e) => setAadhaar(e.target.value)}
                      value={aadhaar}
                      size="small"
                      required
                      disabled={state.lead_source !== "ONA"}
                      placeholder="Aadhaar Number"
                    />
                  </div>
                  <div className="input-div">
                    <label>Voter Id*</label>
                    <TextField
                      name="voterid"
                      onChange={(e) => setVoterId(e.target.value)}
                      value={voterId}
                      size="small"
                      required
                      disabled={state.lead_source !== "ONA"}
                      placeholder="Voter Id"
                    />
                  </div>
                  <div className="input-div">
                    <label>Date of Birth*</label>
                  <TextField
                    name="dob"
                    required
                    type="date"
                    size="small"
                    onChange={(e) => setDateOfBirth(e.target.value)}
                    value={dateOfBirth}
                    disabled={state.lead_source !== "ONA"}
                    // label="Date of Birth"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                  </div>
                  <div className="input-div">
                    <label>Connector*</label>
                    <TextField
                      name="connector-id"
                      required
                      select
                      size="small"
                      onChange={(e)=>setconnector(e.target.value)}
                      value={connector}
                      disabled={email !== "rupesh.bishnoi@credin.in"}
                    >
                      {connectorData.map((data) => (
                        <MenuItem key={data._id} value={data.connectorId}>
                          {data.connectorName}
                        </MenuItem>
                      ))}
                    </TextField>
                  </div>
                  <div className="input-div">
                    <label>Lead Type*</label>
                    <TextField
                      name="lead-type"
                      required
                      size="small"
                      onChange={(e)=>setLeadType(e.target.value)}
                      value={leadType}
                      disabled={state?.borrower_uniqueno}
                      select
                      placeholder="Lead Type"
                      SelectProps={{ native: true }}
                    >
                      <option value="Borrower">Borrower</option>
                      <option value="CoBorrower">CoBorrower</option>
                    </TextField>
                  </div>

                  <div>
                  </div>

                  {(companyIdVisible || visible) ? (
                    <>
                      <div className="input-div">
                        <label>Company Id*</label>
                        <TextField
                          name="company-id"
                          required
                          select
                          size="small"
                          onChange={handleCompanyId}
                          value={companyIdSuperadmin}
                        >
                          {data.map((item, id) => (
                            <MenuItem
                              key={id}
                              value={item.company_id}
                              disabled={!item.is_active}
                            >
                              {item.company_id + " " + item.company_name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </div>

                      <div className="input-div">
                        <label>Branch Id*</label>
                        <TextField
                          name="branch-id"
                          required
                          select
                          size="small"
                          onChange={handleBranchId}
                          value={branchIdSuperadmin}
                        >
                          {data2.map((item, id) => (
                            <MenuItem
                              key={id}
                              value={item.branch_id}
                              disabled={!item.is_active}
                            >
                              {item.branch_id + " " + item.branch_name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </div>

                      <div className="input-div">
                        <label>Source Code*</label>
                        <TextField
                          name="source-code"
                          required
                          select
                          size="small"
                          onChange={(e) => setsourceIdSuperadmin(e.target.value)}
                          value={sourceIdSuperadmin}
                        >
                          {data3.map((item, id) => (
                            <MenuItem
                              key={id}
                              value={item.staff_id}
                              disabled={!item.is_active}
                            >
                              {item.staff_id + " " + item.staff_name}
                            </MenuItem>
                          ))}
                        </TextField>
                      </div>
                    </>
                  ) : null}


                </div>
                {/* <div className="submitBtn-edit-lead">
                  {/* <Link to="/view"> */}
                  {/* <button type="submit" className="btn2">
                    Update
                  </button> */}
                  {/* </Link> */}
                {/* </div> */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    margin: "1.5rem 0",
                  }}
                >
                  <Button type="submit" variant="contained">
                    Update
                  </Button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <ToastContainer />
        <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      </div>
    </>
  );
}
